import React from 'react';
import MiniItemCard from './MiniItemCard';
import { Box, Flex } from '@chakra-ui/react';
import { BusinessItem } from '../../store/page/types';

interface MiniItemRowProps {
  items: BusinessItem[]
  businessName?: string;
  xs?: boolean
}

const MiniItemRow: React.FC<MiniItemRowProps> = ({ items, businessName, xs }) => {
  return (
    <Box overflowX="auto">
      <Flex>
        {items.map((item, index) => (
          <Box key={index} mr={2} minWidth={xs ? "100px" : "330px"} maxWidth={xs ? "150px" :undefined}>
            <MiniItemCard item={item} businessName={businessName} xs={xs}/>
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default MiniItemRow;
